import axios from "axios";
import ConstantList from "../../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/episode-of-care";

export const getEpisodeOfCare = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createEpisodeOfCare = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editEpisodeOfCare = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteEpisodeOfCare = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const getListByPatientId = (patientId) => {
  let url = API_PATH + "/getByPatient/" + patientId;
  return axios.get(url);
};

export const checkPeriod = (obj) => {
  let url = API_PATH + "/checkPeriod";
  return axios.post(url, obj);
};

export const createdCheckPeriod = (obj) => {
  let url = API_PATH + "/createdCheckPeriod";
  return axios.post(url, obj);
};


